'use client'

// src/shared.ts
var commonStyles = {
  fontSize: "inherit",
  fontWeight: "inherit",
  textAlign: "inherit",
  bg: "transparent"
};

export {
  commonStyles
};
//# sourceMappingURL=chunk-6XCKNNTK.mjs.map